define('components/decorators/filters',[
    'jquery',
    '../util/reload-fragments',
    'components/decorator',
    'components/util/clearbutton',
    'components/handlers/filters_locations',
    'components/util/financeTreeUtil',
    'components/util/locale'
],function( $, reload, decorator, clearButtonUtil, locationUtil, financeTreeUtil, locale ){

    //CI-7336 Added refresh timeout constant
    var REFRESH_TIMEOUT_SLOW = 2000;
    var REFRESH_TIMEOUT_FAST = 200;
    var ENTER_KEY = 13;

    var FORM_ERROR_HEADER = 'form-errors';
    $.extend(companyInfo.decorators,{

        'filters': function(){
            //CI-7336 Default to not closing on select
            $.fn.select2.defaults.closeOnSelect = false;

            var component = $(this);
            var form = component.find('#main-form');
            var queryInput = component.find('[name="query"]');
            var filters = $('#filters');
            var results = $('#results');
            var reloadType = form.data('reload-type');
            var reloadId;
            var timeout;
            var changeSource = {};
            var filterNames = [];
            var paramCount = [];
            var focusRestoreProperties; //CI-7336 attempt to restore focus after submit
            var hasChanged = false; //CI-7336 Added flag to determine if the form was changed

            // We wait for decoration to be finished to call reloadFilters because some decorators
            // like filters-finance can create additional filters
            var subscriptionToken = PubSub.subscribe('DECORATION_FINISHED', function() {
              reloadFilters();
              // We only want this to run once so we unsubscribe after it's done
              PubSub.unsubscribe(subscriptionToken);
            });

            // This debounce utility should only be used in functions that call reload
            // TODO make all for submssion events go through this function instead scheduleSubmit()
            function debounce(fn, time) {
              var timeout;
              function cancelDebounce() {
                if (timeout) {
                  reload.cancel();
                  clearTimeout(timeout);
                  timeout = null;
                }
              }
              function debounceWrapper() {
                clearTimeout(timeout);
                timeout = setTimeout(function() {
                  fn.apply(null, arguments);
                }, time);
              }
              debounceWrapper.cancel = cancelDebounce;
              return debounceWrapper;
            }

            component.on('submit', form, handleSubmit);
            form.change(function(e){
                changeSource = e.target;
                hasChanged = true;

                //check that the changeSource formparent === #main-form
                //if not it's a form in a form.
                var parentForm = $(changeSource).closest("form");
                if(form.attr("id") === parentForm.attr("id")){
                    cancelSubmit();
                    submit();
                }
            });

            /**
             * CI-7336
             * Added function to test wether a element is a text input
             * @param {*} el 
             */
            function isTextInput(el) {
                return el.tagName === "INPUT" && el.type === "text";
            }

            /**
             * CI-7336
             * Added function to cancel submission
             */
            function cancelSubmit() {
                reload.cancel();
                clearTimeout(timeout);
                timeout = undefined;
            }

            /**
             * CI-7336
             * Schedule a new submission and cancel the previous one
             */
            function scheduleSubmit(delay) {
                cancelSubmit();
                timeout = setTimeout(handleSubmit,delay); 
            }

            /**
             * CI-7336
             * isFormElement checks wether the target is a valid form element
             */
            function isFormElement(target) {
                var select2Drop = document.getElementById("select2-drop");
                return (
                    target.className.indexOf('select2') > -1 || 
                    target.tagName === "INPUT" || 
                    (select2Drop && select2Drop.contains(target))
                );
            }

            /**
             * CI-7336
             * Submission on focus change
             * - Ignore changes when the focus moves from a select2 element (because that happens when you select a dropdown item while the text input was selected)
             * - Cancel submissions when moving focus to a text input which is not a select2 element
             */
            filters.on('focusout', function (e) {
                if(!hasChanged) {
                    return;
                }

                if(e.target.className.indexOf("select2") > -1) {
                    return;
                }

                if(
                    e.relatedTarget && 
                    isTextInput(e.relatedTarget) &&
                    e.relatedTarget.className.indexOf("select2") === -1) {
                    submit.cancel(); // Because focusout on some elements also triggers form change which uses debounce function
                    cancelSubmit();
                }
                else {
                    handleSubmit();
                }
            });

            /**
             * CI-7336
             * Catch enter keys. 
             * Select2 seems to prevent submits so we need to do some extra work to get that fixed 
             */
            filters.on('keydown', function (e) {
                if(e.which === ENTER_KEY) {
                    scheduleSubmit(REFRESH_TIMEOUT_FAST);
                }
            });

            function patchSelect2(type) {

                /**
                 * CI-7336
                 * Override triggerChange function of select2 so that
                 * we can distinqish between changes coming from normal form elements and clicks coming from the select2 dropdown
                 */
                var oldTriggerChange = Select2.class[type].prototype.triggerChange;
                Select2.class[type].prototype.triggerChange = function (details) {

                    if(!filters[0].contains(this.container[0])) {
                        oldTriggerChange.call(this, details);
                        return;
                    }

                    hasChanged = true;

                    if(details.added) {
                        //CI-7336 Close is always triggered when there is 1 item left in the selectbox (even though closeOnSelect=false)
                        if(this.results.children().length <= 1) {
                            scheduleSubmit(REFRESH_TIMEOUT_FAST);
                        }

                        //yes, we ignore all other adds until the user defocuses the selectbox 
                    }
                    else if(details.removed) {

                        //CI-7336 When removing the last item we will trigger a faster reload
                        if(this.data().length === 0) {
                            scheduleSubmit(REFRESH_TIMEOUT_FAST);
                        }
                        else {
                            scheduleSubmit(REFRESH_TIMEOUT_SLOW);
                        }
                    } 
                };

                var oldInitContainer = Select2.class[type].prototype.initContainer;
                Select2.class[type].prototype.initContainer = function () {

                    oldInitContainer.call(this);

                    //we only respond to key events when this select2 element is inside the filter sidebar
                    if(filters[0].contains(this.container[0])) {
                        this.opts.closeOnSelect = false;
                    }
                };

                /**
                 * CI-7336
                 * Opening a select2 causes a submission cancel
                 * (however we still need to keep the hasChanged state, because we need to reload later)
                 */
                var oldOpen = Select2.class[type].prototype.open;
                Select2.class[type].prototype.open = function () {
                    cancelSubmit();
                    oldOpen.call(this);
                };
 
                /**
                 * CI-7336
                 * Monkeypatch the close function of select2 because clicking outside the dropdown can not be catched by normal
                 * events (click, mousedown etc).
                 */
                var oldClose = Select2.class[type].prototype.close;
                Select2.class[type].prototype.close = function () {
                    if(this.opened() && hasChanged) {
                        scheduleSubmit(REFRESH_TIMEOUT_FAST);
                    }
                    oldClose.call(this);
                };

                /**
                 * CI-7336
                 * This overrides the default behaviour to NOT select the first item when the select box opens and closeOnSelect = true
                 */
                var oldPostProcess = Select2.class[type].prototype.postprocessResults;
                Select2.class[type].prototype.postprocessResults = function (data, initial, noHighlightUpdate) {
                    oldPostProcess.call(this, data, initial, noHighlightUpdate); 
                    if (this.highlight() == -1 && noHighlightUpdate !== false){
                        this.highlight(0);
                    }
                };
             }

             patchSelect2('multi');

            /**
             * from the target, check the datafield filter-family and filter-family-minimuminput
             * if the field is part of a family, and the minimuminput is > 0
             * you need to check that at least the minimum amount of fields in that family are filled, before reloading.
             * for example: the financefield dropdown, should not submit the form, before 1 of the other fields in the family
             * is also filled.
             * @param  {target} elm the element that has changed
             * @return {boolean}     [description]
             */
            function checkMimimumValueInput(elm){
              var $targetComp = $(elm);
              var filterFamily = $targetComp.data("filter-family");
              var minimumInput = $targetComp.data("filter-family-minimuminput");

              if(filterFamily && minimumInput>0){
                //now check how many other family members have a values
                var valueCounter = 0;
                var $familyMembers = $("[data-filter-family="+filterFamily+"]").each(function(){
                  if($(this).val() !== undefined && $(this).val() !== null && $(this).val() !== ''){
                    valueCounter ++;
                  }
                });
                if(valueCounter < minimumInput){
                  return false;
                }
              }
              return $targetComp.val() !== undefined && $targetComp.val() !== null && $targetComp.val() !== '';
            }

            function handleSubmit(e) {
              if (e) {
                e.preventDefault();
              }
              submit();
            }

            var submit = debounce(function() {
                //CI-7336 reset values
                timeout    = undefined;

                $("#select2-drop").select2("close"); //CI-7336 close all dropdowns on submit

                var params = form.serializeArray();
                var newParams = [];
                var refreshPage = false;
                paramCount = [];
                var isFinanceFilterDone = false;

                //FIX: remove the download so that spinner in search field will be shown. 
                //Clicking on the download button (handlers/filter.js) causes the download class to be added but should not show a spinner in the search button
                form.removeClass("download");

                //first check if the user wants to completly refresh the page, or do a reload of the filters.
                //complete reload is done for example for exports of data.
                if(form.data('refresh') !== undefined){
                  refreshPage = true;
                  form.removeData('refresh');
                }
                if(!refreshPage){
                  setLoading();
                }


                params.forEach(function(param) {
                    //if the param.name begins with "_", it's from thymeleaf and we do not need to send it.
                    if ((param.name !== 'page' || changeSource.name === 'page') && !param.name.match(/^_/)) {
                        //when the fieldname is of the finance collection than the data needs to be refactored for correct output

                        if(param.name.match(/^finance[a-z0-9\-]*/)){
                          isFinanceFilterDone = handleFinanceFields(param, isFinanceFilterDone);
                        }
                        if(param.name === 'regStartDate' || param.name === 'regEndDate'){
                            if (param.value) {
                                var newValue = param.value.replace(/[./]/g,'-')
                                    .split('-')
                                    .reverse()
                                    .join('-');
                                var newParam = param.name + '=' + newValue;
                                newParams.push(newParam);
                            }
                        }else{
                          //when the fieldname is locations, you need to refactor the data to the correct output
                          switch(param.name){
                              //the value of sectors is send as commaseperated list. should be as multiple parametrs
                              case "sectors":
                                  setParamCountItem(param);
                                  if (param.value !== "") {
                                      var values = param.value.split(",");
                                      values.forEach(function(v) {
                                          var newSectionParam = "sectors="+v;

                                          newParams.push(newSectionParam);
                                      });
                                  }

                                  break;
                              case "location":
                                  var data = $(".input.location-selector").select2('data');
                                  var locationParams = [];
                                  data.forEach(function(d){
                                      locationParams.push(convertLocationParam(d));
                                  });
                                  if(locationParams.length > 0){
                                      setParamCountItem(param);
                                      param = param.name+"="+JSON.stringify(locationParams);
                                      newParams.push(param);
                                  }
                                  break;
                              //do not submit the referrer field if it exists
                              case "referrer":
                                  break;
                              default:
                                  if(param.value){
                                      setParamCountItem(param);
                                      param = param.name + '=' + encodeURIComponent(param.value);
                                      newParams.push(param);
                                  }
                          }
                        }



                    }
                });
                if (form.data('add-param')) {
                    newParams.push(form.data('add-param'));
                    form.removeData('add-param');
                }

                var url = [location.pathname,newParams.join('&')].join('?');

                if(refreshPage){
                  window.location = url;
                  return;
                }
                reload( 
                    reloadType, 
                    url, 

                    //post replace
                    function(){
                        unsetLoading();
                        if(changeSource.name === 'page') {
                            window.scrollTo(0,0);
                            queryInput.focus();
                        }
                        reloadFilters();
                    }, 

                    false,
                    
                    //pre replace
                    function () {
                        hasChanged = false;
                    }
                );

                //handle the financefilter fields
                function handleFinanceFields(param, done){
                    if(param.name !== "financeType" || done){
                      return true;
                    }

                    //get all the finance fields, so you get a count of all these fields
                    var financeElms = $('[data-finance-pos]');
                    financeElms.each(function(){

                      //get values of the fields needed.
                      var financeTypeData = $(this).find("[data-finance-field=type]").select2('data');
                      var financeMin = $(this).find("[data-finance-field=min]");
                      var financeMax = $(this).find("[data-finance-field=max]");

                      setParamCountItem(param);
                      if(financeTypeData){
                        var finParam;
                        if(financeTypeData && financeTypeData.unit !== 'percent'){
                            finParam = financeTypeData.id + '=' + financeTreeUtil.MultiplyValue(financeMin.val(), 1000) + '..' + financeTreeUtil.MultiplyValue(financeMax.val(), 1000);
                        }else{
                            finParam = financeTypeData.id + '=' + locale.setNumeric2Server(financeMin.val()) + '..' + locale.setNumeric2Server(financeMax.val());
                        }

                        newParams.push(finParam);
                      }

                    });
                    return true;

                }
            }, 100);



            //convert the location param to a json string
            function convertLocationParam(data){
                var param={
                    t: locationUtil.translateType(data.type),
                    n: data.name,
                    ai: data.additionalinfo,
                    ait: locationUtil.translateType(data.additionalinfoType)
                };
                return param;
            }

            function isInArray(value, array) {
              return array.indexOf(value) > -1;
            }

            function setParamCountItem(param){
               if(param){
                  var allFiltersWithName = filters.find('[name='+param.name+']:not([disabled])');

                  //there could be multiple filters with the same name (for example finance).
                  //they have the same name, but different family.
                  //loop through all and check the family names.
                  //and add the unique family names to the paramCount
                    $(allFiltersWithName).each(function(){
                      var paramName = param.name;

                      //if filter is part of family, count filterfamily only once (ex. min and max in postalcode)
                      //if filter is an orphan, count all the filters with the same name. (ex. status in organisation)
                      var filterFamily = $(this).data('filter-family');
                      var filterOrphan = $(this).data('filter-orphan');


                      if(!checkMimimumValueInput($(this))){
                        return;
                      }


                      if(filterFamily){
                        paramName = filterFamily;
                      }else if(filterOrphan){
                        paramName = param.name+param.value;
                      }


                      if ($.inArray(param.name, filterNames) !== -1 &&
                          param.value !== '' &&
                          ($.inArray(paramName, paramCount) === -1)
                          ) {

                          paramCount.push(paramName);
                      }
                    });
                }

            }
            function setFilterCountText(){
                var $paramCount = $('#paramCount');
                var $clearElm = $($paramCount.closest("[data-handler=filters-clear]"));
                if (paramCount.length > 0){
                    var suffix = companyInfo.lang === 'de' ? ' Filter' : (paramCount.length === 1 ? ' filter' : ' filters');
                    $paramCount.text(paramCount.length + suffix);
                    $clearElm.removeClass("disabled");

                } else {
                    var noFiltersSuffix = companyInfo.lang === 'de' ? 'Filter' : 'filters';
                    $paramCount.text(noFiltersSuffix);
                    $clearElm.addClass("disabled");
                }
            }

            function setLoading(){
                filters.addClass('loading');
                results.addClass('loading');
            }

            function unsetLoading(){
                form.removeClass('submitted');
                filters.removeClass('loading');
                results.removeClass('loading');
            }



            function reloadFilters(){
                filters.find('[name]:not([disabled])').each(function() {
                    filterNames.push($(this).attr('name'));
                });
                //Check paramCount
                form.serializeArray().forEach(function(param) {
                    if (!param.name.match(/^_/)) {
                        setParamCountItem(param);
                    }
                });

                clearButtonUtil.setClearInputFieldsIcons(form);
                setFilterCountText();
            }

        }

    });

});

